// src/screens/student/flashcards/Flashcards.js
import React, { useContext, useEffect, useState } from 'react';
import '../../../assets/css/student/flashcards/FlashCards.css';
import StudentLayout from '../../../layouts/student/studentlayout/StudentLayout';
import axios from 'axios';
import AppContext from '../../../context/AppContext';

const FlashCards = () => {
  const { baseUrl } = useContext(AppContext);
  const [activeTab, setActiveTab] = useState('my-decks');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showStudyMode, setShowStudyMode] = useState(false);
  const [selectedDeck, setSelectedDeck] = useState(null);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [studyStats, setStudyStats] = useState({ correct: 0, incorrect: 0, skipped: 0 });
  const [myDecks, setMyDecks] = useState([]);
  const [sampleCards, setSampleCards] = useState([]);
  // const myDecks = [
  //   {
  //     id: 1,
  //     name: 'React Hooks',
  //     description: 'Essential React Hooks concepts',
  //     subject: 'Web Development',
  //     cardCount: 24,
  //     masteredCount: 18,
  //     lastStudied: '2 hours ago',
  //     createdBy: 'You',
  //     isAIGenerated: true
  //   },
  //   {
  //     id: 2,
  //     name: 'Data Structures Basics',
  //     description: 'Arrays, Linked Lists, Stacks, Queues',
  //     subject: 'Computer Science',
  //     cardCount: 32,
  //     masteredCount: 20,
  //     lastStudied: '1 day ago',
  //     createdBy: 'You',
  //     isAIGenerated: false
  //   },
  //   {
  //     id: 3,
  //     name: 'Machine Learning Terms',
  //     description: 'ML terminology and concepts',
  //     subject: 'AI/ML',
  //     cardCount: 40,
  //     masteredCount: 15,
  //     lastStudied: '3 days ago',
  //     createdBy: 'You',
  //     isAIGenerated: true
  //   }
  // ];


  // {
  //   id: 1,
  //   question: 'What is useState in React?',
  //   answer: 'useState is a Hook that lets you add React state to function components. It returns an array with two values: the current state and a function to update it.',
  //   difficulty: 'easy',
  //   mastered: true
  // },


  const viewAllConversations = () => {
    const formData = new FormData();
    formData.append("chstudent_id", 1);
    axios
      .post(`${baseUrl}/student/ilamai/viewAllConversations`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        setMyDecks(response.data.conversations);
        // setIsTyping(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };



  const handleStartStudy = (deck) => {
    setSelectedDeck(deck);
    setSampleCards(deck.chflashcards);
    setCurrentCardIndex(0);
    setIsFlipped(false);
    setStudyStats({ correct: 0, incorrect: 0, skipped: 0 });
    setShowStudyMode(true);
  };

  const handleFlipCard = () => {
    setIsFlipped(!isFlipped);
  };

  const handleCardResponse = (response) => {
    setStudyStats({
      ...studyStats,
      [response]: studyStats[response] + 1
    });

    // Move to next card
    if (currentCardIndex < sampleCards.length - 1) {
      setCurrentCardIndex(currentCardIndex + 1);
      setIsFlipped(false);
    } else {
      // Study session complete
      alert('Study session complete! Great work!');
      setShowStudyMode(false);
    }
  };

  const handlePreviousCard = () => {
    if (currentCardIndex > 0) {
      setCurrentCardIndex(currentCardIndex - 1);
      setIsFlipped(false);
    }
  };

  const handleNextCard = () => {
    if (currentCardIndex < sampleCards.length - 1) {
      setCurrentCardIndex(currentCardIndex + 1);
      setIsFlipped(false);
    }
  };

  const currentCard = sampleCards[currentCardIndex];
  const progress = ((currentCardIndex + 1) / sampleCards.length) * 100;

  useEffect(() => {
    viewAllConversations()
  }, [])

  return (
    <StudentLayout>
      <div className="flashcards">
        {!showStudyMode ? (
          <>
            {/* Header */}
            <div className="page-header">
              <div className="page-title-section">
                <div className="page-title-icon">🎴</div>
                <div>
                  <h1 className="page-title">Flashcards</h1>
                  <p className="page-description">Study with flashcards and track your progress</p>
                </div>
              </div>

            </div>

            {/* Stats */}
            <div className="flashcards-stats">
              <div className="stat-card">
                <div className="stat-icon">🎴</div>
                <div>
                  <div className="stat-value">{myDecks.length}</div>
                  <div className="stat-label">My Decks</div>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">📚</div>
                <div>
                  <div className="stat-value">96</div>
                  <div className="stat-label">Total Cards</div>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">✅</div>
                <div>
                  <div className="stat-value">53</div>
                  <div className="stat-label">Mastered</div>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">🔥</div>
                <div>
                  <div className="stat-value">7</div>
                  <div className="stat-label">Day Streak</div>
                </div>
              </div>
            </div>

            {/* Tabs */}
            <div className="tabs-container">
              <div className="tabs-header">
                <div
                  className={`tab-item ${activeTab === 'my-decks' ? 'active' : ''}`}
                  onClick={() => setActiveTab('my-decks')}
                >
                  My Decks
                  <span className="tab-badge">{myDecks.length}</span>
                </div>

              </div>

              {/* My Decks */}
              {activeTab === 'my-decks' && (
                <div className="decks-grid">
                  {myDecks.map(deck => (
                    <div key={deck.id} className="deck-card">

                      <h3 className="deck-name">{deck.title}</h3>
                      <div className="deck-subject">{deck.subject == null ? "" : deck.subject.name}</div>
                      <div className="deck-stats">
                        <div className="stat-item">
                          <span>🎴</span>
                          <span>{deck.chflashcards == null ? 0 : deck.chflashcards.length} cards</span>
                        </div>

                      </div>

                      <div className="deck-actions">
                        <button
                          className="btn btn-primary btn-full"
                          onClick={() => handleStartStudy(deck)}
                        >
                          Study Now
                        </button>

                      </div>
                    </div>
                  ))}
                </div>
              )}


            </div>
          </>
        ) : (
          /* Study Mode */
          <div className="study-mode">
            <div className="study-header">
              <button
                className="back-btn"
                onClick={() => setShowStudyMode(false)}
              >
                ← Back to Decks
              </button>
              <h2 className="study-title">{selectedDeck?.name}</h2>
              <div className="study-counter">
                {currentCardIndex + 1} / {sampleCards.length}
              </div>
            </div>

            {/* Progress Bar */}
            <div className="study-progress">
              <div className="study-progress-bar">
                <div
                  className="study-progress-fill"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>


            {/* Flashcard */}
            <div className="flashcard-container">
              <div
                className={`flashcard ${isFlipped ? 'flipped' : ''}`}
                onClick={handleFlipCard}
              >
                <div className="flashcard-front">
                  <div className="card-label">Question</div>
                  <div className="card-content">
                    {currentCard?.question}
                  </div>
                  <div className="flip-hint">Click to flip</div>
                </div>
                <div className="flashcard-back">
                  <div className="card-label">Answer</div>
                  <div className="card-content" style={{ fontSize: 14,height: 400, overflowY:"scroll" }}>
                    {currentCard?.answer}
                  </div>
                  <div className="flip-hint">Click to flip back</div>
                </div>
              </div>

              {currentCard?.difficulty && (
                <div className={`difficulty-badge ${currentCard.difficulty}`}>
                  {currentCard.difficulty === 'easy' && '🟢 Easy'}
                  {currentCard.difficulty === 'medium' && '🟡 Medium'}
                  {currentCard.difficulty === 'hard' && '🔴 Hard'}
                </div>
              )}
            </div>

            {/* Controls */}
            <div className="study-controls">
              <button
                className="control-btn"
                onClick={handlePreviousCard}
                disabled={currentCardIndex === 0}
              >
                ← Previous
              </button>


              <button
                className="control-btn"
                onClick={handleNextCard}
                disabled={currentCardIndex === sampleCards.length - 1}
              >
                Next →
              </button>
            </div>

            <div className="study-hint">
              💡 Tip: Try to answer before flipping the card!
            </div>
          </div>
        )}
      </div>
    </StudentLayout>
  );
};

export default FlashCards;